import { dashboardJobsAdapter } from './dashboardJobsAdapter';
import {
  IGetDashboardJobsParams,
  IGetDashboardJobsInfoParams,
  dashboardJobsApi,
} from './dashboardJobsApi';
import { IDashboardJob, IDashboardJobsInfo } from './dashboardJobsTypes';

async function getDashboardJobs(params: IGetDashboardJobsParams): Promise<IDashboardJob[]> {
  const dashboardJobsAPI = await dashboardJobsApi.getDashboardJobs(params);

  return dashboardJobsAPI.map((job) => dashboardJobsAdapter.toDashboardJob(job));
}

async function getDashboardJobsInfo(
  params?: IGetDashboardJobsInfoParams,
): Promise<IDashboardJobsInfo> {
  const dashboardJobsInfoAPI = await dashboardJobsApi.getDashboardJobsInfo(params);

  return dashboardJobsAdapter.toDashboardJobsInfo(dashboardJobsInfoAPI);
}

export const dashboardJobsService = {
  getDashboardJobs,
  getDashboardJobsInfo,
};
